module.exports = __webpack_public_path__ + "static/media/14.ac35ae9b.png";